import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InputLabel, Autocomplete, TextField } from '@mui/material'
import { Wrapper, FormSelectWrap, LabelWrapper, FormReq, FormLabel, FormError, FormPlaceholder } from './style'

const MuiSelectAutoComplete = (props) => {
  const {
    data,
    placeholder,
    onChange,
    selectlabel = 'label',
    selectvalue = 'value',
    minwidth = '100%'
  } = props

  // if (!Array.isArray(data)) {
  //   return false
  // }

  const [selectedValue, setSelectedValue] = useState(props.value)

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue.value)
    const customEventObject = { target: newValue }
    onChange(customEventObject, newValue)
  }
  // consoleLog('props.value ', props.value, selectedValue, selectvalue)

  return (
  <Wrapper>
      {props.title && <LabelWrapper>
        {props.title && <FormLabel title={`${props?.required ? 'This is a required field!' : ''}`} bold={props?.bold}>
          {props.title}{props?.required && <FormReq> *</FormReq>}
        </FormLabel>}
        {props?.endAdornment && props?.endAdornment}
      </LabelWrapper>}
      <FormSelectWrap variant={props?.varient || 'standard'} className='selectWrap' style={{ minWidth: minwidth }}>
        {props?.placeholder && props?.value === '' && false && <FormPlaceholder className={`formPlaceholder ${props?.label ? 'isLabel' : ''} ${props?.disabled ? 'isDisabled' : ''}`}>{props.placeholder}</FormPlaceholder>}
        {props?.label && props?.value === '' && <InputLabel id={props.name} className='selectPlaceholder'>{props.label}</InputLabel>}
        {props?.data &&
          <Autocomplete
            {...props}
            labelId={props.name}
            id={props.name}
            value={props.value}
            label={props.value}
            onChange={handleChange}
            // disableCloseOnSelect
            disableClearable
            disablePortal
            options={data}
            placeholder={selectedValue || props.value ? '' : placeholder}
            // getOptionLabel={(option) => option.label}
            // renderOption={(props, option) => (
            //   <StyledMenuItem single='true' value={option[selectvalue]}>
            //     {option[selectlabel] || ''}
            //   </StyledMenuItem>
            // )}
            renderInput={(params) => <TextField {...params} label={props?.label} variant='standard' />}
            // renderInput={(params) => <TextField {...params} placeholder={selectedValue || props.value ? '' : placeholder} variant='standard' />}
          />
        }
        {selectlabel !== 'label' && selectvalue !== 'value' && <p>NOTE: selectlabel && selectvalue parameter not supported</p>}
      </FormSelectWrap>
      {props?.error && <FormError className='selectError'>{props?.error}</FormError>}
  </Wrapper>
  )
}

MuiSelectAutoComplete.propTypes = {
  data: PropTypes.array,
  label: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  bold: PropTypes.bool,
  disabled: PropTypes.bool,

  varient: PropTypes.string,
  name: PropTypes.string,
  endAdornment: PropTypes.node,
  value: PropTypes.string,
  minwidth: PropTypes.string,
  onChange: PropTypes.func,
  selectlabel: PropTypes.string,
  selectvalue: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  menuprops: PropTypes.object
}

export default MuiSelectAutoComplete
